module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatter",
    attrs: {
      "id": "illustrations"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#plate09"
    }
  }, [_vm._v("Next he kissed her lips and she kissed his and . . . when the two little slave-girls saw their young master go in unto the damsel, Anis al-Jalis, they cried out")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#plate10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One night as he laid by her side . . . she awoke and sat upright. . . . When Ghanim heard her words and knew that she was a concubine of the Caliph, he drew back")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He set his breast against hers; but when he felt waist touch waist his strength failed him, and she . . . threw him to the ground")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When the vile slave heard this from her, he waxt more enraged and his eyes grew redder: and he came up to her and, smiting her with the sword on her neck, wounded her to the death")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#plate13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So at last we lifted up the door; and, going in, found him dead, with his flesh torn into strips and bits and his bones broken. When we saw him in this condition it was grievous to us")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#plate14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I stood behind the door . . . and ere I knew it a damsel ran up . . . she had tucked up her trousers to her knees")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#plate15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King . . . being violently enraged, seized a dagger, and was about to strike Taj al-Muluk with it")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0